import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../BaseModule/Components/BaseModal/BaseModal';
import MultiMediaViewer from './MultiMediaViewer';
import { DocumentationFile } from '../../../../graphql/graphql';
import { Size } from '../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	file: DocumentationFile;
}

const MultiMediaViewerModal: React.FC<Props> = props => {
	return (
		<BaseModal {...props} title='base.shared.document' size={Size.LG}>
			<MultiMediaViewer file={props.file} />
		</BaseModal>
	);
};

export default MultiMediaViewerModal;
